import React from "react";
import "../../../pages/Surveys/style.css"

import cogoToast from "cogo-toast";
import "survey-core/defaultV2.min.css";
import "survey-creator-core/survey-creator-core.min.css";
import { Label, Input, Button } from "reactstrap";
import { useState, useEffect, useRef, useMemo, useCallback } from "react";
import { genericGet, genericPost , getDownloadablePayslip} from "../../../services/Api";
import { SUCCESS_RESULT, ENDPOINTS,LOCAL_PATHS } from "../../../Constants";
import ability from '../../config/defineAbility';
import { PERMS } from '../../config/perms'
import { useReactToPrint } from 'react-to-print';
import ReactToPrint from 'react-to-print';


import {
  
  Modal,
  ModalHeader,
  ModalBody,
  ModalFooter,
 
} from 'reactstrap';
import { Spinner } from "reactstrap";
import { FaTimes, FaEdit, FaFileExport, FaArrowRight } from "react-icons/fa";
import { AgGridReact } from "ag-grid-react";
import "ag-grid-community/dist/styles/ag-grid.css";
import "ag-grid-community/dist/styles/ag-theme-alpine.css";
import { useHistory } from "react-router-dom";
import { PulseLoader } from "react-spinners";
import { Component } from "ag-grid-community";
import { EbmsLoading } from "../../../services/Utils";

const Payslip = (props) => {
  const history = useHistory();
  const [is_loading, setIsLoading] = useState(false);
  const { data } = (props.location && props.location.state) || {};
  const [rowData, setRowData] = useState([]);
  const gridRef = useRef();
  const componentRef = useRef();
  const [pdfUrl, setPdfUrl] = useState(null);

  const [gridApi, setGridApi] = useState(null);
  const [year, setyear] = useState('')
  const [month, setmonth] = useState('')
 const [payslip_pdf, setpayslip_pdf] = useState(null)
const [selected_payroll, setselected_payroll] = useState(null)
const [is_loading_data, setIs_loading_data] = useState(false);


 
 
 
  useEffect(() => {
   fetch_data();
    return () => {};
  }, []);

  const fetch_data = () => {
    setIsLoading(true);
 


getDownloadablePayslip(ENDPOINTS.GET_PAYSLIP,data)
      .then((pdfBlob) => {
        setIs_loading_data(false)
   
    console.clear();
    console.log(pdfBlob)
          try {
            const pdfUrl = URL.createObjectURL(pdfBlob);
            setPdfUrl(pdfUrl);
          } catch (error) {
            alert(error)
          }
          setIs_loading_data(false);

         
        
      })
      .catch((e) => {
        alert(e);
        global.handle_api_error(e);
      });
  };

 

 

  

  
  return (
    <center>
     
        <div className="row">
        
        {is_loading_data && <EbmsLoading></EbmsLoading>}
          <div className="col-md-12">
            {pdfUrl && (
              <iframe
                id="invoice_iframe"
                height={900}
                download="Payment Voucher"
                width={900}
                src={pdfUrl}
                title="Invoice PDF"
                type="application/pdf"
                style={{ border: "none", marginTop: "20px" }}
              />
            )}
          </div>
        </div>
    
    </center>
  );  };
 

export default Payslip;
